import { createRouteRef } from '@backstage/core-plugin-api';

export const teamEditRouteRef = createRouteRef({
  id: 'team-management:team-edit',
});

export const teamCreateRouteRef = createRouteRef({
  id: 'team-management:team-create',
});
